/**
 * Enum representing supported video platforms for URL extraction.
 * Used by the extractVideoUrls utility to categorize detected video URLs.
 */
export enum VideoPlatform {
  youtube = 'youtube',
  google_drive = 'google_drive',
  digitalocean_cdn = 'digitalocean_cdn',
  direct_mp4 = 'direct_mp4',
  other = 'other',
}
